export default {

    download: function (data, dataType, headers, defaultFilename) {
        let blob = new Blob([data], {type: dataType})
        let url = window.URL.createObjectURL(blob)

        let contentDisposition = headers['content-disposition']
        let filename = defaultFilename
        if (contentDisposition) {
            let filenameMatch = contentDisposition.match(/filename="(.+)"/)
            if (filenameMatch.length === 2)
                filename = filenameMatch[1]
        }

        let link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        link.style.display = 'none'

        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    },
}

//* Format to swiss date format
export function formatDate(time) {
    if (time === undefined || time === null || time === '')
        return '---';
    const date = new Date(time);
    const formatOptions = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
    }
    return date.toLocaleString('de-CH', formatOptions);
}

export function addDate(dt, amount, dateType) {
    switch (dateType) {
        case 'days':
            return dt.setDate(dt.getDate() + amount) && dt;
        case 'weeks':
            return dt.setDate(dt.getDate() + (7 * amount)) && dt;
        case 'months':
            return dt.setMonth(dt.getMonth() + amount) && dt;
        case 'years':
            return dt.setFullYear( dt.getFullYear() + amount) && dt;
    }
}

//Validate PhoneNumber
export function validatePhoneNumber(phoneNumber) {
    const regex = new RegExp(/^(\+|00|0)?([1-9][0-9]{6,14})$/);
    return regex.test(phoneNumber);
}

//Validate String is not undefined, null or empty
export function isTextNotEmpty(text) {
    return text !== undefined && text !== null && text !== '';
}

export function validateEmail(email) {
    const regex = new RegExp(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/)
    return regex.test(email);
}

export function validatePrefix(prefix) {
    const regex = new RegExp(/^([1-9][0-9]{0,11})(?:\s*,\s*([1-9][0-9]{0,11}))*$/)
    return regex.test(prefix);
}

const currencyFormat = new Intl.NumberFormat('de-CH', { style: "currency", currency: "CHF" })

export function formatPrice(price) {
    return currencyFormat.format(price)
}

const numberFormat = new Intl.NumberFormat('de-CH')

export function formatBigNumber(number) {
    return numberFormat.format(number)
}

export async function wait(time) {
    return new Promise(resolve => {
        setTimeout(resolve, time);
    });
}

export function json2Table(json) {
    if (!json || json.length === 0) {
        return '<p>No data</p>';
    }
    let cols = Object.keys(json[0]);
    let headerRow = cols.map(col => `<th>${col}</th>`).join('');
    let bodyRows = json.map(row => {
        let cells = cols.map(col => `<td>${row[col]}</td>`).join('');
        return `<tr>${cells}</tr>`;
    }).join('');
    return `
        <table border="1" cellspacing="0" cellpadding="5">
            <thead><tr>${headerRow}</tr></thead>
            <tbody>${bodyRows}</tbody>
        </table>
    `;
}
